export interface IPropertyOption {
    id: number | string;
    name: string;
    position?: number;
}
